import { getNestedSlices } from '../../utils/nested-slices';
import { resolvePersonalizationRule, type PersonalizationMatch } from '../../utils/personalization-cookie-match';

function collectSlices(nodes: any[] = []): any[] {
    return nodes.filter(Boolean).flatMap((node) => [node, ...collectSlices(getNestedSlices(node))]);
}

function formatSource({ source, value }: PersonalizationMatch): string {
    if (source === 'query') return `query|${value.replace('=', '|')}`;
    if (source === 'referrer') return `referrer|${value}|existing user`;
    return `cookie|login-personalisation|${value}`;
}

// Entries `name,name|source|...` (slices with the same source are listed together) joined with ` | `.
export function getPersonalizedSlices(vueState: any): string {
    const query = Object.fromEntries(new URLSearchParams(window.location.search));
    const namesBySource = new Map<string, string[]>();

    collectSlices(vueState.pages?.page?.body).forEach((slice) => {
        const rule = resolvePersonalizationRule(slice.data?.personalization, { query, referrer: document.referrer });
        if (!rule) return;
        // A matched rule may replace nested `slices`: report each of them by its `pageDetailsA` label (or name)
        let names = rule.item.data?.slices?.map((item) => item.pageDetailsA || item.name) || [slice.name];
        if (rule.source === 'query') names = ['content'];
        names = names.filter(Boolean);
        if (!names.length) return;
        const source = formatSource(rule);
        namesBySource.set(source, [...(namesBySource.get(source) || []), ...names]);
    });

    return [...namesBySource].map(([source, names]) => `${[...new Set(names)].join(',')}|${source}`).join(' | ');
}
